export default __webpack_public_path__ + "static/media/print_24px_outlined.e0c5fe00.svg";